import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import ButtonComp from 'common/components/Button/ButtonComp';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import { RootState } from 'common/store/AppStore';
import { urlWithTenant } from 'common/utils/utilFunctions';

import styles from './Unauthorized.module.scss';

const UnauthorizedPage = () => {
	const navigate = useNavigate();

	const isAppDrawerOpen = useSelector(
		(state: RootState) => state.common.isAppDrawerOpen,
	);
	const goBackHandler = useCallback(() => {
		navigate(urlWithTenant(rrcpDashboardRoutes.parent));
	}, []);
	return (
		<div
			className={
				isAppDrawerOpen
					? styles['page-background-expand']
					: styles['page-background-collapse']
			}
		>
			<h1>Permission Denied</h1>
			<p>You do not have permission to access this page.</p>
			<ButtonComp
				btnType="primary"
				clickHandler={goBackHandler}
				data-testid="go-back"
				compClass={styles['go-back']}
			>
				Go to Home
			</ButtonComp>
		</div>
	);
};

export default UnauthorizedPage;
